import { render, staticRenderFns } from "./marketingSMS.vue?vue&type=template&id=46abbfb6&scoped=true&"
import script from "./marketingSMS.vue?vue&type=script&lang=js&"
export * from "./marketingSMS.vue?vue&type=script&lang=js&"
import style0 from "./marketingSMS.vue?vue&type=style&index=0&id=46abbfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46abbfb6",
  null
  
)

export default component.exports